var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":_vm.route('profile.show')}},[_c('img',{staticClass:"tw-block tw-h-9 tw-w-auto",attrs:{"width":"1206","height":"283","src":require('~/images/ht-logo-main.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }